import DateFilter from '@/components/date-filter';
import store_operation from '@/store/mods/caisse/operations'
import $ from 'jquery';

export default {
    name: 'bons-attente',
    components: {
        DateFilter
    },
    props: {
        active_role: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            is_loading: true,
            is_empty: false,
            msg_error: '',
            bons_medical: [],
            is_month: false,

            fields: [
                'date', { key: 'data_type', label: 'Type bon' }, 'libelle', { key: 'patient', label: 'Patient' },
                { key: 'etat', label: 'Statut' }, { key: 'actions', label: 'Action.s' }
            ],
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,

            bon_state_filters: [
                { id: 0, libelle: 'En attente' },
                { id: 1, libelle: 'Payé' }
            ],
            filter_bon: { id: 0, libelle: 'En attente' },

            type_bons: [
                { slug: '', libelle: 'Tous les types' },
                { slug: 'bon_consultation', libelle: 'Bon de consultation' },
                { slug: 'analyse', libelle: 'Bon d\'analyse' },
                { slug: 'examen', libelle: 'Bon d\'examen' }
            ],
            filter_type: { slug: '', libelle: 'Tous les types' }
        }
    },

    watch: {
        active_role() { this.fieldsSetter(); this.currentPage = 1; this.current_date_filter.page = 1; this.fetchBonMedical() },
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                
                if (this.filter_by_date.slug) {
                    $('.date-filter-cbons').modal('show')
                }
            }
        },

        filter_bon() {
            this.current_date_filter.status = this.filter_bon.id
            this.fetchBonMedical()
        },

        filter_type() {
            this.fieldsSetter()
            this.current_date_filter.data_type = this.filter_type.slug
            this.fetchBonMedical()
        },

        curr_month() {
            const data = {
                month: this.curr_month ? this.curr_month.id : "",
                one_date: "",
                from_date: "",
                to_date: "",
                status: this.filter_bon.id,
                data_type: this.filter_type.slug
            }
            this.is_month = !!this.curr_month
            this.current_date_filter = data
            this.fetchBonMedical()
        },
    },

    computed: {

    },

    mounted() {
        this.fieldsSetter()

        const data = {
            month: "",
            // Les bons restent en attente au-delà du jour de création.
            one_date: "",
            from_date: "",
            to_date: "",
            status: this.filter_bon.id,
            data_type: this.filter_type.slug
        }
        this.current_date_filter = data
        this.fetchBonMedical()
    },

    methods: {
        fieldsSetter() {
            if (this.active_role == 'ROLE_ACCUEIL') {
                this.fields = [
                    'date', { key: 'data_type', label: 'Type bon' }, 
                    'libelle', { key: 'patient', label: 'Patient' },
                    { key: 'etat', label: 'Statut' },
                ]
            } else if (this.active_role == 'ROLE_CAISSIERE') {
                this.fields = [
                    'date', { key: 'data_type', label: 'Type bon' }, 
                    'libelle', { key: 'patient', label: 'Patient' },
                    { key: 'etat', label: 'Statut' },
                    { key: 'actions', label: 'Action.s' }
                ]
            }
        },

        setTypeBon(data_type) {
            let type = ''
            this.type_bons.forEach(el => {
                if (el.slug == data_type) {
                    type = el.libelle
                }
            });
            return type
        },

        fetchBonMedical() {
            this.is_loading = true
            store_operation.getListeBonMedical(this.current_date_filter).then((response) => {
                this.bons_medical = response.data
                this.total_pages = response.last_page

                if (this.bons_medical.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.msg_error = "Une erreur s'est produite ! Merci de réesayer"
            })
        },

        filterByDate(date) {
            this.operations_tobe_canceled = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                page: 1,
                status: this.filter_bon.id,
                data_type: this.filter_type.slug
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.fetchBonMedical(data)
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.fetchBonMedical(this.current_date_filter)
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.fetchBonMedical(this.current_date_filter)
            }
        },

        gotoPage(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.fetchBonMedical(this.current_date_filter)
            }
        },

        goToPayment(info) {
            console.log(info);
            this.$store.commit("SET_TYPE_ACTION_SELECTED", info.data_type)
            this.$store.commit("SET_CHOSEN_PATIENT", info.patient);
            this.$store.commit('SET_MEDECIN_BON_PREPARE', null);

            let url_to_go = ''

            if (info.data_type == "bon_consultation") {
                const info_bon = {
                    consult_id: info.data_id, 
                    consult_name: info.libelle, 
                    consult_abr: ''
                }
                this.$store.commit("SET_TYPE_CONS_SELECTED", info_bon);
                this.$store.commit("SET_SELECTED_BON_CONSOMMABLES", info.consommable_bon);
                const complement = info.info_complementaire || {}
                this.$store.commit('SET_MEDECIN_BON_PREPARE', {
                    patient_id: info.patient.id, type_id: info.data_id,
                    medecin_id: complement.medecin_id || null,
                    medecin_nom: complement.medecin_nom || '',
                    // N° de bon et date d'expiration saisis à l'Accueil, gardés à la Caisse (04/10/2026).
                    num_bon_societe: complement.num_bon_societe || '',
                    date_expire_bon: complement.date_expire_bon || ''
                });
                url_to_go = { name: 'Bon consultation' }
            } else {
                let selected_prestations = []
                info.prestations.forEach(prestation => {
                    const tmp_prest = {
                        id: prestation.data_id,
                        nom: prestation.libelle,
                        prix: prestation.prix_unitaire,
                        // Type de facturation choisi à l'accueil (bons enregistrés avant le 15/10/2026 : normal)
                        type_facturation: prestation.type_facturation || 'normal',
                    }
                    selected_prestations.push(tmp_prest)
                });

                if (info.data_type == "analyse") {
                    this.$store.commit("SET_ANALYSES_SELECTED", selected_prestations);
                } else if (info.data_type == "examen") {
                    this.$store.commit("SET_EXAMENS_SELECTED", selected_prestations);
                }
                url_to_go = { name: 'Bon medical' }
            }
            this.$store.commit("SET_IS_PRE_SAVED_BON", true);
            this.$store.commit("SET_SELECTED_BON_ID", info.id)

            this.$router.push(url_to_go)
        },

        printBonMedical(info_bon) {
            let title = ''
            if (info_bon.data_type == 'bon_consultation') {
                title = 'Bon de consultation'
            } else if (info_bon.data_type == 'analyse') {
                title = 'Bon d\'analyse'
            } else if (info_bon.data_type == 'examen') {
                title = 'Bon d\'examen'
            }

            const data = {
                data_type: info_bon.data_type,
                title: title,
                data_id: info_bon.data_id,
                libelle: info_bon.libelle,
                patient: {
                    nom: info_bon.patient.nom,
                    sexe: info_bon.patient.sexe,
                    age: info_bon.patient.age,
                    num_dossier: info_bon.patient.num_dossier,
                    telephone_mobile: info_bon.patient.telephone_mobile
                },
                patient_id: info_bon.patient.id,
                user: {
                    name: info_bon.user.name,
                    titre: info_bon.user.titre
                },
                info_complementaire: info_bon.info_complementaire
            }
            console.log("> i:",data);
            
            this.info_bon = data
            this.is_bon_consultation = (info_bon.data_type == 'bon_consultation') ? true : false

            this.$emit('emitPrintBonMedical', { info_bon: this.info_bon, is_bon_consultation: this.is_bon_consultation })
        }
    }
}
